import { getFirAnalytics } from '../../Api/firebase/firebaseConnect'
import { executeWithRetry } from '../networking/networkHelpers'

export const logEvent = async (name: string, params?: any | undefined) => {
    const { logEvent: firLogEvent } = await import('firebase/analytics')
    await executeWithRetry(async () => {
        const fa = await getFirAnalytics()
        firLogEvent(fa, name, params)
    }, `log analytics event: ${name}`)
}